module.exports = __webpack_public_path__ + "img/reject.fa1da20e.svg";